import React, { useState, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import { RxCross2 } from "react-icons/rx";

export default function SignatureView({ handleSubmit, onClose }) {
    const [signMethod, setSignMethod] = useState(0);
    const [typedSignature, setTypedSignature] = useState("");
    const [selectedFont, setSelectedFont] = useState("cursive");
    const [isSigned, setIsSigned] = useState(false);
    const sigCanvasRef = useRef(null);

    const handleSignMethodChange = (method) => setSignMethod(method);
    const handleTypedSignatureChange = (e) => setTypedSignature(e.target.value);
    const handleFontChange = (e) => setSelectedFont(e.target.value);

    const onSubmitSignature = () => {
        let signatureData;
        if (signMethod === 0) {
            // Extract base64 from SignatureCanvas
            if (isSigned) {
                signatureData = sigCanvasRef.current.toDataURL();
            } else {
                alert("Please sign before submitting.");
                return;
            }
        } else if (signMethod === 1) {
            // Use the typed signature
            if (typedSignature.trim() === "") {
                alert("Please type your signature before submitting.");
                return;
            }
            signatureData = typedSignature.trim();
        }

        // Pass the signature data to the handleSubmit function
        handleSubmit(signatureData);
    };

    return (
        <div className="tw-p-8 tw-fixed tw-inset-0 tw-z-[1000] tw-flex tw-items-center tw-justify-center tw-h-full tw-w-full">
            <div className="tw-flex tw-flex-col tw-items-center tw-bg-white tw-p-6 tw-rounded-lg tw-shadow-lg tw-w-[80%] xl:tw-w-1/2 tw-h-[90vh] tw-relative">
                <div>
                    <RxCross2 className="tw-text-3xl tw-text-primary tw-absolute tw-top-2 tw-right-2 tw-cursor-pointer" onClick={() => onClose()} />
                </div>
                <h2 className="tw-font-bold tw-text-lg tw-text-center tw-text-primary">E-Sign your Contract</h2>
                <div className="tw-flex tw-justify-center tw-mt-4 tw-gap-4">
                    <button
                        className={`tw-px-4 tw-py-2 tw-rounded tw-border tw-text-sm tw-font-medium ${
                            signMethod === 0 ? "tw-bg-primary hover:tw-to-primary_hover tw-text-white" : "tw-bg-gray-200 tw-text-gray-800"
                        }`}
                        onClick={() => handleSignMethodChange(0)}
                    >
                        Finger Signing
                    </button>
                    <button
                        className={`tw-px-4 tw-py-2 tw-rounded tw-border tw-text-sm tw-font-medium ${
                            signMethod === 1 ? "tw-bg-primary hover:tw-to-primary_hover tw-text-white" : "tw-bg-gray-200 tw-text-gray-800"
                        }`}
                        onClick={() => handleSignMethodChange(1)}
                    >
                        Type Sign
                    </button>
                </div>

                <div className="tw-mt-6 tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center">
                    {signMethod === 0 && (
                        <div>
                            <p className="tw-font-medium tw-text-gray-700">Sign Here</p>
                            <SignatureCanvas
                                ref={sigCanvasRef}
                                onEnd={() => {
                                    setIsSigned(true);
                                }}
                                penColor="#232D8E"
                                canvasProps={{
                                    className: "tw-border tw-border-gray-300 tw-rounded",
                                    style: {
                                        height: "200px",
                                        backgroundColor: "#f7f7f7",
                                    },
                                }}
                            />
                        </div>
                    )}
                    {signMethod === 1 && (
                        <div>
                            <p className="tw-font-medium tw-text-gray-700">Type your signature:</p>
                            <div
                                className="tw-text-center tw-py-4 tw-border tw-border-gray-300 tw-rounded tw-bg-white"
                                style={{ fontFamily: selectedFont }}
                            >
                                {typedSignature || "Your Signature"}
                            </div>
                            <input
                                type="text"
                                value={typedSignature}
                                onChange={handleTypedSignatureChange}
                                placeholder="Type your name"
                                className="tw-w-full tw-p-2 tw-border tw-border-gray-300 tw-rounded tw-mt-4"
                                style={{ fontFamily: selectedFont }}
                            />
                            <select
                                value={selectedFont}
                                onChange={handleFontChange}
                                className="tw-w-full tw-mt-4 tw-p-2 tw-border tw-border-gray-300 tw-rounded"
                            >
                                <option value="cursive">Cursive</option>
                                <option value="serif">Serif</option>
                                <option value="monospace">Monospace</option>
                                <option value="sans-serif">Sans-serif</option>
                            </select>
                        </div>
                    )}
                    <div className="tw-w-full xl:tw-w-1/2">
                        <p className="tw-mt-5 tw-text-[#001659] tw-text-sm">
                            By signing the above e-signature, I agree that such signature will be as valid as handwritten signatures to the extent
                            allowed by local law.
                        </p>
                        <button
                            onClick={onSubmitSignature}
                            className="tw-mt-5 tw-bg-primary hover:tw-to-primary_hover tw-w-full tw-rounded tw-px-5 tw-py-1 tw-text-white tw-text-[20px]"
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
